import { render } from "./SavedIndicators.vue?vue&type=template&id=6e85fcbe&scoped=true"
import script from "./SavedIndicators.vue?vue&type=script&lang=js"
export * from "./SavedIndicators.vue?vue&type=script&lang=js"

import "./SavedIndicators.vue?vue&type=style&index=0&id=6e85fcbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e85fcbe"]])

export default __exports__